import { Component, AfterViewInit } from '@angular/core';
import { Authenticationservice } from '../../core/services/authentication.service';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';

declare var $: any;

@Component({
  selector: 'app-sidebar2',
  templateUrl: './sidebar2.component.html',
  styleUrls: ['./sidebar2.component.css']
})
export class Sidebar2Component {


  userdata: any;
  constructor(
    private auth: Authenticationservice,
    private brdservice: BrdsqlService,
  ) {


    let userdata: any = this.auth.Authention();
    let check: any = this.auth.Alertreload();

  }

  ngOnInit(): void { }

  isSidebarOpen = true;
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }


}
